import * as Yup from "yup";

const stripHtml = (value) =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\u200B/g, "")
    .replace(/\s+/g, " ")
    .trim();

const buildNumberSchema = (label, minimum = 0) =>
  Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? NaN
        : value
    )
    .typeError(`${label} must be a number`)
    .moreThan(minimum, `${label} must be greater than ${minimum}`)
    .required(`${label} is required`);

const buildRequiredValueSchema = (label) =>
  Yup.mixed().test(
    `${label}-required`,
    `${label} is required`,
    (value) => String(value ?? "").trim() !== ""
  );

export const createTripCostEstimationSchema = Yup.object().shape({
  tripId: buildRequiredValueSchema("Trip ID"),
  vehicleId: Yup.string().trim().required("Vehicle is required"),
  driverId: Yup.string().trim().required("Driver is required"),
  routeId: Yup.string().trim().required("Route is required"),
  distance: buildNumberSchema("Distance"),
  fuelPricePerLiter: buildNumberSchema("Fuel Price per Liter"),
  vehicleFuelEfficiency: buildNumberSchema("Vehicle Fuel Efficiency per Liter"),
  foodAllowancePerDay: buildNumberSchema("Driver Allowance"),
  tripDuration: buildRequiredValueSchema("Trip Duration"),
  maintenanceCostPerKm: buildNumberSchema("Maintenance Cost per KM", -1),
  estimatedTollCost: buildNumberSchema("Estimated Toll Cost", -1),
  estimatedRevenue: buildNumberSchema("Estimated Revenue"),
  attachments: Yup.array().nullable(),
  notes: Yup.string()
    .nullable()
    .test("notes-max", "Notes are too long", (value) => stripHtml(value).length <= 1500),
});
